import React from 'react'
import { useSelector } from 'react-redux'

import { Avatar, AvatarStatus, Icon } from '../../../../../components/UI'
import MultiTalent from '../../../../../components/Shared/MultiTalent'

import {
  selectRole,
  selectUserData,
} from '../../../../../routing/fetchingfunction/user/user.reducer'

import { useGetInfo, useUserName } from '../../../../../hooks'

import { arrayFromNumber, getAvatarUrl, getProfileByRole } from '../../../../../helpers'
import getFlags from 'helpers/getFlagurl'

const ProfilePublicViewUser = () => {
  const role = useSelector(selectRole)
  const userData = useSelector(selectUserData)

  const { formattedWorldLanguages } = useGetInfo()

  const profile = getProfileByRole(userData, role)
  const userName = useUserName()

  const userLanguages =
    userData &&
    userData.profile.languages
      .map((language) => {
        return formattedWorldLanguages.find((worldLanguage) => worldLanguage.value === language)
      })
      .filter(Boolean)

  if (!profile) {
    return null
  }

  const userLanguagesContent =
    userLanguages &&
    userLanguages.map((language) => {
      return (
        <span
          key={language.value}
          className="text-primary-100 text-xs bg-white-50 !py-1 !px-2 rounded-lg !mr-1"
        >
          {language.label}
        </span>
      )
    })

  const starsContent = arrayFromNumber(8).map((star) => {
    return <Icon key={star} name="sun-check" className="w-[36px] h-[36px]" />
  })

  return (
    <div className="w-full mt-[10px] p-[20px] pb-[32px] rounded-[10px] border-[1px] border-[#FFCA84] bg-[#FFF5EE] flex items-center justify-center flex-col">
      <div className="w-full flex items-center justify-end">
        <Icon name="flag" color="#F79009" className="w-[24px] h-[24px]" />
      </div>

      <div className="mt-[10px] relative">
        <Avatar src={getAvatarUrl(profile.profile_picture)} className="w-[124px] h-[124px]" />

        <AvatarStatus status="online" />
      </div>

      <div className="w-full flex items-center justify-center mt-[16px]">
        <h2 className="text-2xl font-bold text-primary-100 max-w-[80%]">{userName}</h2>

        <Icon name="heart" color="#EF4343" className="w-[36px] h-[36px] ml-[10px]" />
      </div>

      <div className="mt-[16px] w-full flex items-center justify-center">
        {true && <MultiTalent />}

        <div className="gap-x-[2px] flex items-center ml-[8px]">{starsContent}</div>
      </div>

      <div className="mt-[16px] w-full flex items-center justify-center gap-x-[16px]">
        <div className="flex justify-center items-center">
          <img
            className="w-[24px] h-[24px]"
            src="/assets/icon/checkbox-multiple-line.svg"
            alt="Check"
          />

          <span className="text-primary-100 font-normal ml-1 text-sm">
            {/* TODO: make dynamic data */}
            {170}
          </span>
        </div>

        <div className="flex justify-center items-center">
          <img className="w-[24px] h-[24px]" src="/assets/icon/user-green.svg" alt="User" />

          <span className="text-primary-100 font-normal ml-1 text-sm">
            {/* TODO: make dynamic data */}
            {19}
          </span>
        </div>

        <div className="flex justify-center items-center">
          <span className="text-[#B733DD] text-sm font-semibold">ROI</span>

          <span className="text-primary-100 font-normal ml-1 text-sm">
            {/* TODO: make dynamic data */}
            {36}%
          </span>
        </div>
      </div>

      <div className="mt-[10px] flex items-center justify-center w-full">
        <div className="flex items-center justify-center mr-[8px]">
          <div className="mr-[9px]">
            <img className="block" src="/assets/icon/fontOrangeIcon.png" alt="language" />
          </div>

          {userLanguagesContent}
        </div>

        <div className="flex items-center justify-center gap-x-[10px]">
          <div className="flex items-center justify-center">
            <Icon className="mr-[6px]" name="global-line" color="#F79009" />

            <img
              className="block size-6 rounded-full object-cover"
              src={getFlags(userData?.profile?.country_of_origin)}
              alt={`${userData?.profile?.country_of_origin} flag`}
            />
          </div>

          <div className="flex items-center justify-center">
            <Icon className="mr-[6px]" name="home" color="#F79009" />

            <img
              className="block size-6 rounded-full object-cover"
              src={getFlags(userData?.profile?.country_of_residence)}
              alt={`${userData?.profile?.country_of_residence} flag`}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfilePublicViewUser
